import { Dispatch, SetStateAction } from 'react'
import { useLazyQuery } from '@apollo/client'
import { getTemplateByEnrichment } from '@/lib/processQueries'
import { download64File } from '@/lib/utils'
import { basicEnrichment, interestConflictEnrichment } from './constants'
import { BasicDetail } from './BasicDetail'
import { InterestConflictDetail } from './InterestConflictDetail'

export default function DataDetail({
  processData,
  setProcessData,
  enrichmentType,
  enrichmentTypeKey,
  isViewMode,
}: {
  processData: FormProcessData
  setProcessData: Dispatch<SetStateAction<FormProcessData>>
  enrichmentType: number | undefined
  enrichmentTypeKey: string | undefined
  isViewMode: boolean
}) {
  const [getTemplate] = useLazyQuery(getTemplateByEnrichment)

  const handleGetTemplate = () => {
    getTemplate({
      variables: {
        enrichmentTypeId: enrichmentType,
      },
    }).then((res) => {
      const data = res.data.getTemplateByEnrichment
      download64File(data.encodedFile, data.fileName, data.mimeType)
    })
  }
  const rutsACount = processData.ruts_a?.length || 0
  const rutsBCount = processData.ruts_b?.length || 0

  return (
    <div className="pt-4 w-full">
      {(enrichmentTypeKey === basicEnrichment || !enrichmentType) && (
        <div className="mb-4">
          <BasicDetail
            processData={processData}
            setProcessData={setProcessData}
            handleGetTemplate={handleGetTemplate}
            enrichmentType={enrichmentType}
            isViewMode={isViewMode}
          />
          <p className="text-xs text-grey-3 mt-2">
            RUTs cargados: <strong>{rutsACount}</strong>
          </p>
        </div>
      )}
      {enrichmentTypeKey === interestConflictEnrichment && (
        <div className="mb-4">
          <InterestConflictDetail
            processData={processData}
            setProcessData={setProcessData}
            handleGetTemplate={handleGetTemplate}
            enrichmentType={enrichmentType}
            isViewMode={isViewMode}
          />
          <div className="flex justify-between text-xs text-grey-3 mt-2">
            <p>
              RUTs Colaboradores: <strong>{rutsACount}</strong>
            </p>
            <p>
              RUTs Proveedores: <strong>{rutsBCount}</strong>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
